import { RefObject, useEffect, useState } from 'react';

/**
 * Tracks a `ref` and returns the corresponding DOM element when it's available.
 *
 * @param ref The React ref to track.
 * @returns The DOM element associated with the ref, or null if it's not ready.
 */
// export function useRefElement<T extends HTMLElement>(
//   ref: RefObject<T>
// ): T | null {
//   const [element, setElement] = useState<T | null>(null);

//   useEffect(() => {
//     // Update state when the `ref` changes
//     if (ref.current) {
//       setElement(ref.current);
//     }
//   }, [ref]);

//   return element;
// }

export function useRefElement<T extends HTMLElement = HTMLElement>(
  ref: RefObject<T | null>,
): T | null {
  const [element, setElement] = useState<T | null>(null);

  useEffect(() => {
    setElement(ref.current);
  }, [ref]);

  return element;
}
